import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AlertsService } from '../../alerts-custom.service';
import { AlertsvarService } from '../../alertsvar.service';
import { KeyValue } from '@angular/common';
import { FormControl, UntypedFormBuilder, Validators } from '@angular/forms';
import { SharedService } from 'src/app/services/shared.service';
import { TimeZoneService } from 'src/app/services/time-zone.service';

@Component({
  selector: 'app-update-action',
  templateUrl: './update-action.component.html',
  styleUrls: ['./update-action.component.scss']
})
export class UpdateActionComponent implements OnInit, OnDestroy {
  alert_state: any;
  alert_status: any;
  alert_reason: any;
  selected_status = "0";
  selected_category = "0";
  selected_subcategory = "0";
  selected_reason = "0";
  limit = 100
  updateAction = this.fb.group({
    comments: new FormControl('', Validators.maxLength(this.limit)),
    selectedUser: new FormControl('', Validators.required)
  })
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: UntypedFormBuilder,

    private ref: MatDialogRef<UpdateActionComponent>,
    private alertService: AlertsService,
    public alertVarService: AlertsvarService,
    private sharedService: SharedService,
    private timezoneservice: TimeZoneService,

  ) { }


  updateActionSpinnerState: boolean = false;
  actRemove = new FormControl(false);
  error_msg: string = ''
  error_status: boolean = false;
  selectedAction: string = ""
  // actionList = ["incident", "close"];
  $destroy: Subject<boolean> = new Subject()
  selectedActionStatusId: string = ""
  selectedActionStateId: string = ""
  selectedActionStatusText: string = ""
  selectedActionStateText: string = ''
  selectedReasonText: string = ''
  alertActionMetadata: any;
  UserList = []
  ngOnInit(): void {
    console.log(this.data)
    this.data.userlist.forEach(element => {
      // this.UserList.push({ disp: element, value: element })
      this.UserList.push(element)
    });
    setTimeout(() => {
      this.selectedUser.setValue(this.UserList[0].value);

    }, 0);
    this.selected_status = this.data.selectedstatus
    this.alertActionMetadata = this.sharedService.metaData.alert.factsheetMeta.alertUpdateAction

    this.selectedActionStatusText = this.alertActionMetadata.defaultActionStatus
    this.selectedActionStateText = this.alertActionMetadata.defaultActionState
    this.alert_status = this.alertActionMetadata.defaultActionStatusValue
    this.alert_state = this.alertActionMetadata.defaultActionStateValue
  }


  selectAction(action: any) {
    this.selectedAction = action;
  }

  clearAlertWorkFlowObject() {
    this.alertVarService.alertWorkFlowInfo.selectedAlerts = {}
    this.alertVarService.alertWorkFlowInfo.alertKeys_list = []
    this.alertVarService.alertWorkFlowInfo.alertWorkFlowSelectAll.setValue(false, { emitEvent: false })

  }

  cancelAction() {
    this.ref.close();
  }

  getUserId(username){
    let id 
    this.UserList.forEach(val=>{
      console.log({val})
      if(val.disp === username){
        id = val.value
      }
    })
    console.log({id})
    return id
  }

  submitAction() {
    if (this.selected_reason == '') {
      this.error_msg = this.alertActionMetadata.errors.reason
      this.error_status = true
    }
    if (this.selected_category == '') {
      this.error_msg = this.alertActionMetadata.errors.actionstate
      this.error_status = true
    }
    if (this.selected_status != '' && this.selected_category != '' && this.selected_reason != '') {
      this.error_status = false
      this.updateActionSpinnerState = true;
      const selectedAlert = [];
      const excludeAlert = [];

      // this.data.selectedAlert.forEach((element: string) => {
      //   if (this.alertVarService.alertWorkFlowInfo.selectedAlerts[element].isSelected) {
      //     selectedAlert.push({

      //       alertTime: this.alertVarService.alertWorkFlowInfo.selectedAlerts[element].alerttime,
      //       seq_no: this.alertVarService.alertWorkFlowInfo.selectedAlerts[element].seq_no,
      //     })
      //   }
      // })
      if (!this.alertVarService.SelectAllAlerts) {

        Object.keys(this.alertVarService.eventWorkFlowInfo.selectedAlerts).map((batch: any) => {
          Object.keys(this.alertVarService.eventWorkFlowInfo.selectedAlerts[batch]).map((alertkey: any) => {
            selectedAlert.push(this.alertVarService.eventWorkFlowInfo.selectedAlerts[batch][alertkey])
          })
        })

      }
      else if (this.alertVarService.SelectAllAlerts) {
        Object.keys(this.alertVarService.eventWorkFlowInfo.selectedAlerts).map((batch: any) => {
          Object.keys(this.alertVarService.eventWorkFlowInfo.selectedAlerts[batch]).map((alertkey: any) => {
            if (!this.alertVarService.eventWorkFlowInfo.selectedAlerts[batch][alertkey]["selected"])
              excludeAlert.push(this.alertVarService.eventWorkFlowInfo.selectedAlerts[batch][alertkey])
          })
        })
      }

      const assignReqObj = {
        username: this.sharedService.userName,
        platform: this.alertVarService.alertscollapsedata.selectedalert.platform,
        alertId: this.alertVarService.alertscollapsedata.selectedalert.alertId,
        selectedAlert: selectedAlert,
        exemptedAlert: excludeAlert,
        // action: this.alertActionMetadata.actions[this.selectedActionStatusText].disp,//for history
        action: this.alertActionMetadata.states.status[this.selected_status].disp,//for history
        assigned_user: this.selected_status == '1' ? this.selectedUser.value : this.getUserId(this.sharedService.userName),

        // actionstate: this.selectedActionStateText,
        status: this.selected_status,//status
        actionstate: this.selected_category,//category
        statuscategory: this.selected_subcategory,//subcatagory
        statusreason: this.selected_reason,//reason
        comment: this.comments.value,
        reason: this.selected_reason,
        ref_no: this.alertVarService.chart_ref_no,
        bulk_action: this.alertVarService.SelectAllAlerts,
        template: this.alertVarService.SelectAllAlerts ? { ...this.alertVarService.template_structure } : {},
        selectednode: this.alertVarService.nodeinfo.id,
        season_time: [this.timezoneservice.toUtcTimeZonefromUser(this.alertVarService.advanced_filter_values.start_time).format("YYYY-MM-DD HH:mm:ss"), this.timezoneservice.toUtcTimeZonefromUser(this.alertVarService.advanced_filter_values.end_time).format("YYYY-MM-DD HH:mm:ss")],
        status_filter: [],
        state_filter: [],
        statusreason_filter: []
      }
      //console.log("Action Request Object", assignReqObj)
      this.alertService.postAction(assignReqObj)
        .pipe(takeUntil(this.$destroy))
        .subscribe((res) => {
          this.updateActionSpinnerState = false;
          // this.updateEventList();
          if (res["status"]) {

            if (this.actRemove.value) {
              this.alertVarService.RemoveOnlySelectedEvents()
            }
            this.alertVarService.createtoastmsg({
              type: "success",
              "text": "The action has been successfully updated"
            })
            this.alertVarService.clearAllPageClick()
            this.alertVarService.$alertStatusUpdated.next(true);
          }
          this.ref.close(true);
        },
          (err) => {
            //console.log(err)
            this.updateActionSpinnerState = false;
            console.log({ err })
            this.alertVarService.createtoastmsg({
              type: "error",
              "text": err.error.message || "Failed to update action"
            })
            // this.ref.close(true);

          })
      // .then((result:any) => {
      //   console.log(result)
      //   this.updateActionSpinnerState = false;
      //   this.updateEventList();
      //   this.clearAlertWorkFlowObject()
      //   this.alertVarService.createtoastmsg({
      //     type:"success",
      //     "text":"Alerts Assigned to specific user"
      //   })
      //   // this.ref.close(true);
      //   }).catch((err)=>{
      //     console.log(err)
      //   this.updateActionSpinnerState = false;

      // }).finally(()=>{
      //   this.ref.close(true);
      // })
      // setTimeout(()=>{
      //   console.log("before compone")

      // },5000);

    }

  }
  // if(this.selectedAction){
  //   this.updateActionSpinnerState = true;
  //   const selectedAlert = [];
  //   this.data.selectedAlert.forEach((element:number)=>{
  //     selectedAlert.push({
  //       alertTime:this.alertVarService.eventlist[element].alerttime,
  //       seq_no:this.alertVarService.eventlist[element].seq_no,
  //     })
  //   })
  //   const assignReqObj = {
  //     username: this.userlogonService.userName,
  //     alertId:this.alertVarService.alertscollapsedata.selectedalert.alertId,
  //     selectedAlert,
  //     action:this.selectedAction
  //   }
  //   this.alertService.postAction(assignReqObj)
  //   .pipe(takeUntil(this.$destroy))
  //   .subscribe((res)=>{
  //     this.updateActionSpinnerState = false;
  //     this.ref.close(true);
  //     this.updateEventList();
  //     this.alertVarService.createtoastmsg({
  //       type:"success",
  //       "text":"Alerts Assigned to specific user"
  //     })
  //   },
  //   (err)=>{
  //     this.updateActionSpinnerState = false;
  //   })
  // }


  updateEventList() {
    // this.data.selectedAlert.forEach((element: number) => {
    //   if (this.alertVarService.AlertEvents.hasOwnProperty(element) && this.alertVarService.AlertEvents[element].isSelected) {
    //     this.alertVarService.AlertEvents[element].status = this.alert_status
    //     // this.alertVarService.AlertEvents[element].alertstate = this.selectedActionStateId
    //     this.alertVarService.AlertEvents[element].alertstate = this.alert_state
    //   }
    //   if (this.alertVarService.alertWorkFlowInfo.selectedAlerts[element].isSelected) {
    //     this.alertVarService.alertWorkFlowInfo.selectedAlerts[element].status = this.alert_status;
    //     // this.alertVarService.alertWorkFlowInfo.selectedAlerts[element].alertstate = this.selectedActionStateId
    //     this.alertVarService.alertWorkFlowInfo.selectedAlerts[element].alertstate = this.alert_state;
    //     if (!this.actRemove.value) {
    //       this.alertVarService.alertWorkFlowInfo.selectedAlerts[element].isSelected = false
    //       this.alertVarService.alertWorkFlowInfo.alertWorkFlowSelectAll.setValue(false, { emitEvent: false })
    //     }
    //   }

    // })

  };

  actionStateClick(actionStateText: string, actionStatusText: string, actionStateObj: any, actionStatusObj: any) {
    //console.log("actionStateClick", actionStateText, actionStatusText, actionStateObj, actionStatusObj)
    this.alert_state = actionStateObj.id
    this.alert_status = actionStatusObj.value
    this.selectedActionStateText = actionStateText
    this.selectedActionStatusText = actionStatusText
    this.selectedReasonText = ''
  }
  reasonClick(status_id: string, state_id: string, reason: string) {
    //console.log("reasonClick", status_id, state_id, reason)
    this.alert_reason = state_id
    this.selectedReasonText = reason
    this.selectedActionStatusId = status_id
    this.selectedActionStateId = state_id
    this.error_status = false

  }




  //unsort the key value from the array of objects
  originalOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return 0;
  }
  ngOnDestroy(): void {
    this.$destroy.next(true);
  }
  select_status(status: any) {
    this.selected_status = status;
    this.selected_reason = "0";
    this.selected_subcategory = "0";
    this.selected_category = "0";
  }
  select_category(category: any) {
    this.selected_category = category;
    this.selected_reason = "0";
    this.selected_subcategory = "0";
  }
  select_subcategory(subcategory) {
    this.selected_subcategory = subcategory;
    this.selected_reason = "0";
  }
  get comments() {
    return this.updateAction.get('comments')
  }
  get selectedUser() {
    return this.updateAction.get('selectedUser')
  }

  select_reason(reason) {
    //console.log(this.comments.hasError('maxLength'), this.comments.errors?.maxlength)
    if (this.selected_reason != reason) {
      this.selected_reason = reason;
      this.comments?.setValue('', { emitEvent: false });
    }
  }
}
